import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

import { baseUrl } from "config/config";
import { postApiCall } from "../../services/apiHelper";
import { RootState } from "../store";

interface ComplianceResponse {
    complianceType? : string,
    complianceTypeComment? : string
}



interface InitialState {
  data: ComplianceResponse,
  error: string,
  loading: boolean,
  cacheKey: string | undefined,
  isNoData: boolean
};

const initialState: InitialState = {
  data: {} as ComplianceResponse,
  error: '',
  loading: false,
  cacheKey: undefined,
  isNoData: false
};

const complianceDataSlice = createSlice({
  name: "complianceData",
  initialState,
  reducers: {
    resetState: (state) => {
      state.data = {} as ComplianceResponse;
      state.error = "";
      state.loading = false;
      state.cacheKey = undefined;
      state.isNoData = false;
    },
  },
  extraReducers: (builder) => {
    // eslint-disable-next-line   
    builder.addCase(getComplianceData.pending, (state) => {
      state.loading = true;
    }),
      builder.addCase(getComplianceData.fulfilled, (state, action: PayloadAction<ComplianceResponse>) => {
        state.loading = false;
        state.data = action.payload;
        state.cacheKey = 'capitalCache';
      }),
      builder.addCase(getComplianceData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'something went wrong';
      })
  }
});

export const getComplianceData = createAsyncThunk
  <
    ComplianceResponse,
    any,
    { state: RootState }
  >
  ("getComplianceData", async (payload: any, { getState, rejectWithValue }) => {
    const state = getState().complianceData;

    if (state.cacheKey === 'capitalCache') {
      // Return the current data if it exists in the state and cacheKey is set
      return state.data;
    }

    const response = await postApiCall(`${baseUrl}Compliance/GetComplianceData`,payload).then((res: any) =>
      res);
    console.log("response",response)
    return response || {};
  });

export const { resetState: resetComplianceDataStore } = complianceDataSlice.actions;

export default complianceDataSlice.reducer;
